import { render, staticRenderFns } from "./DemoTable.vue?vue&type=template&id=5a61053e&scoped=true"
import script from "./DemoTable.vue?vue&type=script&lang=js"
export * from "./DemoTable.vue?vue&type=script&lang=js"
import style0 from "./DemoTable.vue?vue&type=style&index=0&id=5a61053e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a61053e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a61053e')) {
      api.createRecord('5a61053e', component.options)
    } else {
      api.reload('5a61053e', component.options)
    }
    module.hot.accept("./DemoTable.vue?vue&type=template&id=5a61053e&scoped=true", function () {
      api.rerender('5a61053e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DemoTable.vue"
export default component.exports